/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeMinusIcon16Light = forwardRef('SearchLoupeMinusIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 7a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.751 7.5a5.749 5.749 0 1 1 10.152 3.696l2.706 2.705a.5.5 0 1 1-.707.707l-2.706-2.705A5.749 5.749 0 0 1 .751 7.5ZM6.5 2.75a4.749 4.749 0 1 0 0 9.498 4.749 4.749 0 0 0 0-9.498Z" })));
});
